var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#ec7b47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,20c16.569,0,30,13.431,30,30S66.569,80,50,80S20,66.569,20,50S33.431,20,50,20 M50,15  c-19.299,0-35,15.701-35,35s15.701,35,35,35s35-15.701,35-35S69.299,15,50,15L50,15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.627,42.163l-7.221-4c-1.209-0.669-2.729-0.232-3.398,0.976s-0.232,2.729,0.976,3.398l3.273,1.813l-3.273,1.813  c-1.208,0.669-1.645,2.19-0.976,3.398c0.457,0.824,1.31,1.289,2.189,1.289c0.41,0,0.825-0.101,1.209-0.313l7.221-4  c0.005-0.003,0.007-0.008,0.012-0.011c0.392-0.219,0.73-0.544,0.964-0.965C45.272,44.354,44.835,42.832,43.627,42.163z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.749,46.163l-3.273-1.813l3.273-1.813c1.208-0.669,1.645-2.19,0.976-3.398c-0.669-1.208-2.191-1.643-3.397-0.976  l-7.222,4c-0.012,0.007-0.017,0.019-0.028,0.026c-0.383,0.219-0.718,0.535-0.947,0.95c-0.669,1.208-0.232,2.729,0.976,3.398l7.222,4  c0.384,0.212,0.799,0.313,1.209,0.313c0.879,0,1.732-0.465,2.188-1.289C67.394,48.354,66.957,46.832,65.749,46.163z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.454,66.827c-0.588,0-1.178-0.206-1.653-0.626c-3.802-3.355-8.688-5.204-13.761-5.204s-9.959,1.849-13.761,5.204  c-1.036,0.914-2.614,0.814-3.528-0.22c-0.914-1.035-0.815-2.614,0.22-3.528c4.715-4.163,10.778-6.456,17.069-6.456  c6.292,0,12.354,2.293,17.069,6.456c1.035,0.914,1.134,2.493,0.22,3.528C66.835,66.541,66.146,66.827,65.454,66.827z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejection);
export default __webpack_public_path__ + "static/media/rejection.8906ad205c5455e3766d20afa532a05f.svg";
export { ForwardRef as ReactComponent };